import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

const FormikNumberFormatInput = props => {
  const {
    name,
    value,
    disabled,
    Precision,
    datatype,
    onBlur,
    onChange,
    onKeyPress,
    maxLength,
  } = props;

  const withNotZero = ({ formattedValue, floatValue }) => formattedValue === '' || floatValue !== 0;

  return (
    <NumberFormat
      name={name}
      className="form-control text-input"
      displayType="input"
      decimalScale={Precision}
      disabled={disabled}
      isNumericString
      thousandSeparator={datatype !== 'decimal'}
      type="text"
      value={value}
      isAllowed={withNotZero}
      maxLength={maxLength}
      onBlur={onBlur}
      onChange={onChange}
      onKeyPress={onKeyPress}
    />
  );
};

FormikNumberFormatInput.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
  Precision: PropTypes.number,
  maxLength: PropTypes.number,
  datatype: PropTypes.string,
};

export default FormikNumberFormatInput;
